module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/plan_type_location_photowedding@2x-ec113dd777507cf4dd94aab428459d1b.webp";